const wrapper = document.querySelector('.videoblock__wrapper');

if (wrapper) {
  const play = wrapper.querySelector('.videoblock__play');
  const video = wrapper.querySelector('video');

  play.addEventListener('click', () => {
    play.style.display = 'none';
    video.play();
  });
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.js-youtube-video');
  if (!trigger) return;

  const videoId = trigger.dataset.videoId;
  if (!videoId) return;

  trigger.innerHTML = `
		<iframe
			width="1280"
			height="720"
			src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
			title="YouTube video player"
			frameborder="0"
			loading="lazy"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowfullscreen>
		</iframe>
	`;
});
